import { Link } from "react-router-dom";

var LoadingButton = require("components/utility/LoadingButton");
var ValidatingInput = require("components/utility/ValidatingInput");
var WhooosReadingClientApi = require("wr_apis/apis/wr_client_api/node_package/src/index.js")

require("logins/forgot_password_page.scss");

class ForgotPasswordPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: false, expandMessage: false
		};
	}

	validateForm() {
		return this.refs.usernameEmail.validate();
	}

	onSubmit(e) {
		$wr.nope(e)
		if (!this.validateForm()) {
			return;
		}

		var username = this.refs.usernameEmail.val();
		var client = new WhooosReadingClientApi.LegacyClient();
		this.setState({ loading: true });

		client.postPasswordResets({ username: username }, function(response) {
			var resetData = response.password_reset;
			if (resetData.errors && resetData.errors.length > 0) {
				window.wrNotifications.triggerDropDownNotification({
					text: resetData.errors.join(", "),
					icon: "exclamation-sign", type: "error" }, 6000);

				this.setState({ loading: false });

			} else {
				window.wrNotifications.triggerDropDownNotification({
					title: "Sent!", text: "Check your inbox for instructions to reset your password.",
					icon: "envelope" }, 6000);

				$wr.redirect("/login");
			}
		}.bind(this));
	}

	onFieldFocus() {
		this.setState({ expandMessage: true });
	}

	onFieldBlur() {
		this.setState({ expandMessage: false });
	}

	render() {
		var messageHeight = this.state.expandMessage ? 20 : 0;

		return (
			<div className="forgotPasswordPage container">
				<header className="pageHeader">
					<h1>Forgot your Password?</h1>
				</header>

				<img src={ require("owls/owlfonso-green.png") } className="forgotOwl" />

				<form onSubmit={ this.onSubmit } className="resetForm">
					<p>
						Enter your username below and we will email you instructions to reset your password.
					</p>

					<label htmlFor="usernameEmail">
						Enter Your Username
					</label>

					<ValidatingInput type="text" ref="usernameEmail"
						validators={ ValidatingInput.Validators.PRESENT }
						inputClassName="form-control usernameEmail"
						onFocus={ this.onFieldFocus } onBlur={ this.onFieldBlur } />

					<div className="resetMessage" style={ { height: messageHeight } }>
						We'll email you a link to reset your password
					</div>

					<div className="btnLine">
						<LoadingButton text="Request Reset" loading={ this.state.loading }
							className="btn buttonPrimary" />
						<Link to="/login" className="btn btn-link">Back to login</Link>
					</div>

					<p>
						If you cannot remember your username, reply to any email sent to you from Whooo's Reading, and we will help you reset your password.
					</p>
				</form>
			</div>
		);
	}
};

ForgotPasswordPage.propTypes = PageStrictPropTypes({
});

module.exports = ForgotPasswordPage;



// WEBPACK FOOTER //
// ./modules/components/logins/ForgotPasswordPage.js